// extracted by mini-css-extract-plugin
export default {"band":"TutorBand_band__Ng-Nj","text":"TutorBand_text__Do1jR","link":"TutorBand_link__Zfeme"};